import type { ButtonHTMLAttributes } from 'react';

export enum MControlTabScrollDirection {
  Left = 'left',
  Right = 'right',
}

export type MControlTabScrollProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  direction?: MControlTabScrollDirection;
};
